const menus = [

    {
        id: 1,
        name: 'Explore',
        namesub: [
            {
                id: 2,
                sub: 'Explore all NFTs',
                links: '/explore-02'
            },
            
        ],
    },
    {
        id: 2,
        name: 'Create',
        namesub: [
           
            {
                id: 1,
                sub: 'Create an NFT',
                links: '/create-item'
            },
           
        ],
    },
    
    
]

export default menus;